import { render, staticRenderFns } from "./SetupGoals.vue?vue&type=template&id=2225e228"
import script from "./SetupGoals.vue?vue&type=script&lang=js"
export * from "./SetupGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports